import { RevenueAgentKey, RevenueAgentTask } from "../../types/revenueOps";

export type InertAgentResult = {
  agent_key: RevenueAgentKey;
  status: "not_implemented";
  message: string;
  task?: RevenueAgentTask;
};

function createInertResult(
  agent_key: RevenueAgentKey,
  task?: RevenueAgentTask
): InertAgentResult {
  return {
    agent_key,
    status: "not_implemented",
    message: "Revenue Ops agent automation is not enabled in this foundation release.",
    task,
  };
}

/** TJ's future scope is monitoring Toren software revenue and collections. */
export function runTJRevenueOpsAgent(task?: RevenueAgentTask): InertAgentResult {
  return createInertResult("tj_revenue_ops", task);
}

/** Glenn's future scope is partner pipeline, attribution, and commission review. */
export function runGlennPartnerOpsAgent(task?: RevenueAgentTask): InertAgentResult {
  return createInertResult("glenn_partner_ops", task);
}

export const TJ_REVENUE_OPS_RESPONSIBILITIES = [
  "Monitor failed payments and invoices requiring review",
  "Detect MRR changes and summarize new software revenue",
  "Identify subscriptions without partner attribution",
  "Flag commission entries needing approval",
  "Prepare monthly revenue summaries and payout batch reviews",
] as const;

export const GLENN_PARTNER_OPS_RESPONSIBILITIES = [
  "Review partner-submitted opportunities and duplicates",
  "Flag attribution conflicts and Year 3 eligibility questions",
  "Validate advisory/network override calculations",
  "Explain commission calculations and prepare payout statements",
  "Flag partner inactivity risk and summarize pipeline",
] as const;
